module.exports = __webpack_public_path__ + "img/dianliu3.gif";